export default __webpack_public_path__ + "static/media/banana5.32675285.svg";